require([
    'jquery',
    'base/MbiHelper',
    'base/MbiImageSize',
    'base/MbiMediaQuery'
], function(
    $,
    _,
    mbiImageSize,
    mbiMq
    ) {
    'use strict'


        $('.competence-detail').removeClass('is_open');
        $('.js_open-competence').removeClass('is_active');

    $(document).on('click', '.js_open-competence', function(){

        $('.competence-detail').removeClass('is_open');
        $('.js_open-competence').removeClass('is_active');

        $(this).addClass('is_active');
        var $contentid = '#' + $(this).attr('data-comp-target');
        var content = $(document).find($contentid);
        var target = $(this).parent().nextAll('.competence-detail__row').first();
        if('lap-' in mbiMq.mqArea) {
            $('.competence-detail').removeClass('is_open');
            content.addClass('is_open');

        } else {
            if(target.find('.is_open').length <= 0) {
                target.html(content.clone());
                var tEl = $('.competence-detail__row').find('.is_open');
                //if(tEl){
                    tEl.find('.is_open').removeClass('is_open');
                //}
                setTimeout(function(){
                    target.find($contentid).addClass('is_open');

                },30);
            } else {
                target.html(content.clone());
                target.find($contentid).addClass('is_open');

                // $('.competence-detail__row').find('.is_open').removeClass('is_open');
            }
        }

        setTimeout(function(){
            var off = $('.competence-detail.is_open').offset();
            $('html, body').animate({
                scrollTop: off.top - 160
            },300);
        },1000);
    });

    $(document).on('click', '.js_close-competence', function(){
        $('.competence-detail').removeClass('is_open');
        $('.js_open-competence').removeClass('is_active');
    });

    $(document).on('breakpoint', function(e, data){
        if('lap-' in data.area) {
            $('.competence-detail__row').find('.is_open').removeClass('is_open');
            $('.competence-detail').removeClass('is_open');
        }
    });

    $(document).on('breakpoint',function(k,el){

        if(el.from == 'tablet' && el.to == 'mobileWide') {
            $('.competence-detail').removeClass('is_open');
            $('.js_open-competence').removeClass('is_active');
        }
        if(el.from == 'mobileWide' && el.to == 'tablet') {
            $('.competence-detail').removeClass('is_open');
            $('.js_open-competence').removeClass('is_active');
        }
    });

});

define("root/Assets/Templates/Html/grid/Js/grid", function(){});

